import React from 'react';

const Status = ({ label, status, dot, className, onClick }) => {
	const color = {
		0: 'warning',
		1: 'success',
		2: 'danger',

		INFO: 'info',
		PENDING: 'warning',
		COMPLETED: 'success',
		FAILED: 'danger',
	};
	const kolor = color[status];
	const hasDot = !!(typeof dot === 'undefined');

	return (
		<React.Fragment>
			<div
				id="Status"
				className={`${kolor} rounded-full inline-flex items-center py-1 px-2 fs-12 ${label?.length < 11 ? 'text-uppercase' : ''} ${onClick ? 'copy' : ''} ${className || ''}`}
				onClick={() => onClick && onClick()}
			>
				<div className={`${hasDot ? 'dot' : ''} ${kolor}`} />
				<b>{label}</b>
			</div>
		</React.Fragment>
	);
};

export default Status;
